export default "__VITE_ASSET__DY88LugF__"